




export default {
  name: 'User',
};
